import type { PermissionName } from 'c-sdk';
import type { User } from 'c-entity-types';
import userHasPermissions from './userHasPermissions';

const userHasSomePermissions = (user: User, permissions: PermissionName[]) =>
    userHasPermissions(user, permissions).length > 0;

export default userHasSomePermissions;
